<template>
    <div>
        <div class="cover" :style="getBackgroundCover()">
            <div class="ad_share">
                <div class="actions">
                    <div v-if="editable">
                        <input type="file" name="files" />
                    </div>
                    <button @click="openShareModal()" id="btn_ad_share" class="btn btn-white waves-effect waves-light">
                        <i class="fas fa-share-alt m-r-5"></i> Compartilhar
                    </button>
                </div>

                <div v-if="profile && profile.cta_url" class="cta">
                    <button @click="redirectLeadUrl()" id="btn_lead_cta" class="btn btn-success waves-effect waves-light btn-lg">
                        Tenho Interesse
                    </button>
                </div>
            </div>
        </div>
        <div class="user-info">
            <div class="user-photo img-circle" :style="'background: url(' + user.photo_url + ') no-repeat center/cover'"></div>
            <div class="user">
                <div class="wrap-1">
                    <div class="name">
                        <h1 class="h4">{{ user.full_name }}</h1>
                        <p v-if="user.verified_account" class="verified_badge"><img src="/images/verified.png" alt="" title="Conta Verificada" /> Conta Verificada</p>
                    </div>
                    <div class="status">
                        <p>Online há {{ user.last_activity }}</p>
                        <p class="content">Taxa de resposta : {{ user.response_rate }}</p>
                    </div>
                </div>
                <div class="wrap-2">
                    <div class="mobile">
                        <div v-if="user.verifications.mobile"><i class="fas fa-mobile-alt m-r-10"></i> Telefone verificado</div>
                        <div v-else><i class="fas fa-mobile-alt m-r-10"></i> Telefone não verificado</div>
                    </div>
                    <div class="facebook">
                        <div v-if="user.verifications.facebook"><i class="fab fa-facebook-square m-r-10"></i> Facebook verificado</div>
                        <div v-else><i class="fab fa-facebook-square m-r-10"></i> Facebook não verificado</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-t-30" v-if="data_profile && data_profile.about_host && !editable">
            <div class="about m-t-10">
                <span>SOBRE:</span>
                <p class="m-t-5">{{ data_profile.about_host }}</p>
            </div>
        </div>
        <div class="m-t-30" v-if="editable">
            <div class="about">
                <span class="m-r-10">SOBRE:</span>
                <div class="form-group">
                    <textarea name="" class="form-control m-t-5" placeholder="Use este campo para falar um pouco sobre você, e sobre o tipo de moradia que você oferece." v-model="about" id="" crows="5"></textarea>
                </div>
                <button type="submit" @click="saveAboutText()" class="btn btn-success">Salvar</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['profile', 'user', 'editable', 'ads', 'cover_photo'],
        data() {
            return {
                data_profile: this.profile,
                about: this.profile ? this.profile.about_host : '',
                user_id: this.user.id,
                city_covers: {
                    5213: 'sp',
                    801: 'brasilia',
                    1606: 'bh',
                    3631: 'rio',
                    2853: 'curitiba',
                    4125: 'poa',
                },
            }
        },
        methods: {
            openShareModal() {
                EventBus.$emit('open-modal', 'ad-share-modal', {
                    'profile' : true
                });
            },
            redirectLeadUrl() {
                window.open(this.profile.cta_url);
                window.dataLayer.push({
                    'event': 'direct_lead_host_profile',
                    'event_category': 'direct_lead',
                    'event_label': this.user.id
                });
            },
            getBackgroundCover() {
                return `background: url('${ this.cover_photo }') no-repeat center/cover`;
            },
            saveAboutText() {
                let _this = this;
                axios.post('/host-profile/edit-about', {about: _this.about}).then(res => {
                    if (res.data) {
                        _this.data_profile = res.data.profile;
                        _this.about = res.data.profile.about_host
                        window.App.success('Suas informações foram atualizadas com sucesso!');
                    }
                }).catch(err => {
                    window.App.error('Erro ao salvar informação, atualize a página e tente novamente');
                })
            },
            initPhotoUploader: function () {
                let _this = this;
                setTimeout(() => {
                    let _this = this;
                    $('input[name="files"]').fileuploader({
                        theme: 'onebutton',
                        thumbnails: null,
                        changeInput: function (opt) {
                            return '<button  class="btn btn-white waves-effect waves-light m-r-15"><i class="far fa-images m-r-5"></i> Editar Capa</button>'
                        },
                        upload: {
                            url: '/host-profile/upload-cover-photo',
                            data: null,
                            type: 'POST',
                            enctype: 'multipart/form-data',
                            start: true,
                            synchron: true,
                            beforeSend: function (item) {
                                item.upload.headers = {
                                    'X-CSRF-TOKEN': window.Laravel.csrfToken
                                }
                            },
                            onSuccess: function(data, item) {
                                setTimeout(function() {
                                    _this.data_profile = data.profile;
                                    window.App.success('Foto da capa alterada com sucesso!');
                                }, 400);
                            },
                            onError: function(item) {
                                setTimeout(function() {
                                    window.App.error('Ocorreu um erro ao enviar sua foto. Tente novamente em alguns minutos!');
                                }, 400);
                            },
                        }
                    });
                }, 100);
            }
        },
        mounted() {
            this.initPhotoUploader();
        }
    }
</script>

<style lang="scss" scoped>
    .cover {
        width: 100%;
        height: 250px;
        .ad_share {
            display: block;
            position: relative;
            width: 100%;
            height: 100%;

            .actions {
                display: flex;
                position: absolute;
                right: 30px;
                top: 20px
            }

            .cta {
                display: flex;
                position: absolute;
                right: 30px;
                bottom: 20px
            }
        }
    }
    .wrap-2, .wrap-1 {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        width: calc((100% - 130px) / 2 - 40px);
        flex-wrap: wrap;
    }
    .about {
        margin-top: 30px;
        span {
            font-family: 'Hind Madurai', sans-serif;
            font-weight: 600;
        }
    }
    .user-info {
        display: block;
        position: relative;
        .user-photo {
            height: 100px;
            width: 100px;
            position: absolute;
            top: -30px;
            border: 3px solid lightgray;
            margin-left: 10px;
        }
        .user {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-left: 130px;
            margin-top: 10px;
            flex-wrap: wrap;
            .name {
                .verified_badge {
                    margin-bottom: 0;
                }
                img {
                    width: 20px;
                }
            }
            .status {
                .content {
                    color: #3097D1;
                    font-weight: 600 !important;
                    margin-bottom: 0;
                }
            }
            i {
                font-size: 1.5rem;
            }
        }
    }
@media (max-width: 661px) {
    .cover {
        height: 170px;
    }
    .user-photo {
        top: 30px !important;
    }
    .wrap-2 {
        margin-top: 10px;
    }
    .wrap-2, .wrap-1 {
        width: 100%;
    }
}

@media (max-width: 994px ) and (min-width: 662px) {
    .cover {
        height: 200px;
    }
    .user-photo {
        top: 10px !important;
    }
}
</style>